export default __webpack_public_path__ + "188b48c28e398c000f2a135df0d42b35.svg";